import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setArticleBaseModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class ArticleBaseListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.Article);
    }

    render() {
        return (
            <div className="listdiv">
                <button className="articleListItem" onClick={evt => this.handleTouchTap(false)}>
                    <label className="listItemLabelTop">{this.props.Article.Description}</label>
                    {/* <label className="listItemLabel">{this.props.Article.ArticleNumber}</label> */}
                    <Ink />
                </button>
            </div>
        )
    }
}

ArticleBaseListItem.propTypes = {
    Article: PropTypes.object.isRequired,
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, { setArticleBaseModal })(ArticleBaseListItem)


// WEBPACK FOOTER //
// src/components/ArticleBaseListItem.jsx